@if (loading && !showCalculating && !showCallToAction) {
  <div>
    <div class="loader__container mt-0">
      <div class="loader"></div>
    </div>
    <div class="center-div">{{ loadingMessage }}</div>
  </div>
}
@if (showCalculating && !didErrorOccur) {
  <div class="calculating-loader-container">
    @if (showTemplateReSpreadCalculatingView) {
      <app-template-re-spread-loading-view></app-template-re-spread-loading-view>
    } @else {
      <app-calculating
        [finish]="finishedCalculating"
        (finishedLoading)="hideCalculatingLoader()"
      ></app-calculating>
    }
  </div>
}
@if (didErrorOccur) {
  <div>
    @if (showTemplateReSpreadErrorState) {
      <div class="empty-state-container re-spread-error-empty-state-container">
        <app-table-empty-state
          [emptyStateIcon]="reSpreadErrorIcon"
          [headerText]="reSpreadErrorHeaderText"
          [helpText]="reSpreadErrorHelpText"
        ></app-table-empty-state>
      </div>
    } @else {
      <div class="empty-state-container">
        <div>
          <app-table-empty-state
            [emptyStateIcon]="'fa-exclamation-circle'"
            [headerText]="'Error Loading Financials'"
            [helpText]="'Please reload the page or re-complete the last spread. If the problem persists, contact your administrator.'"
          ></app-table-empty-state>
        </div>
      </div>
    }
  </div>
}
@if (showCallToAction && loading) {
  <div>
    <div class="loader__container">
      <div class="col-6 offset-3">
        <i class="fas fa-mug-hot icon"></i>
        <h4>This is embarrassing! Calculating these financials seems to be taking longer than it should. Go grab a
          coffee - your data should be available soon! If you think there's an issue, please reach out to our
        support team via our in app chat</h4>
      </div>
    </div>
  </div>
}
@if (!loading && hasAccessError) {
  <div>
    <borrower-alert [alertText]="accessErrorText"></borrower-alert>
  </div>
}
@if (!loading && !didErrorOccur && canViewFinancials) {
  <div class="financials-content">
    @if (shouldShowEmptyState && activeDataView) {
      <div class="financials-analysis" [class.fills-host]="!embeddedMode">
        <div class="inner-content financials-toolbar">
          <div class="d-flex flex-wrap toolbar justify-content-between align-items-center">
            <div class="template-name-label-container">
              <h5 class="mb-0">
                {{ formatDataViewName(activeDataView.title) }}
              </h5>
              @if (isPartialStatementSelection) {
                <span class="statement-count-badge clickable-text" (click)="openFilterStatementFlyout()">
                  {{ loadedPeriodCount }} of {{ totalStatementsCount }} statements
                </span>
              }
            </div>
            <div>
              <div class="buttons-container">
                <div id="showHiddenButton" class="btn-group clickable-text"
                  [class.disabled]="showHiddenDisabled" [class.enabled]="!showHiddenDisabled"
                  role="toolbar"
                  (click)="toggleHidden()">
                  @if (showHidden) {
                    <label class="hideHidden"><i class="fas fa-eye-slash pt-1"></i>Hide
                  Hidden</label>
                }
                @if (!showHidden) {
                  <label class="showHidden"><i class="fas fa-eye pt-1"></i>Show Hidden</label>
                }
              </div>
              <div class="btn-group clickable-text showAll" role="toolbar"
                [class.disabled]="removeHiddenDisabled" [class.enabled]="!removeHiddenDisabled"
                (click)="removeShowAll()">
                <label class="showAll"><i class="fas fa-trash pt-1"></i>
              Show All (clears hidden)</label>
            </div>
            <div class="btn-group clickable-text" role="toolbar"
              [class.disabled]="clearUndoDisabled" (click)="undoLastHidden()">
              <i class="fas fa-undo pt-1"></i> Undo Last Show/Hide
            </div>
            <div class="btn-group clickable-text" role="toolbar"
              [class.disabled]="dollarSignDisabled" (click)="toggleDollarSign()">
              @if (dollarSign) {
                <span class="item-checked">
                  <i class="item-checked far fa-check-square"></i><i class="fas fa-dollar-sign"></i>Currency
                </span>
              }
              @if (!dollarSign) {
                <span>
                  <i class="far fa-square"></i><i class="fas fa-dollar-sign"></i>Currency
                </span>
              }
            </div>
            <div class="btn-group clickable-text" role="toolbar"
              [class.disabled]="numbersDisabled" (click)="toggleNumbers()">
              @if (numbers) {
                <span class="item-checked">
                  <i class="item-checked far fa-check-square"></i><i class="fas fa-list-ol"></i>Numbers
                </span>
              }
              @if (!numbers) {
                <span>
                  <i class="far fa-square"></i><i class="fas fa-list-ol"></i>Numbers
                </span>
              }
            </div>
            <div class="btn-group clickable-text" role="toolbar"
              [class.disabled]="commonSizeDisabled" (click)="toggleCommonSize()">
              @if (commonSize) {
                <span class="item-checked">
                  <i class="item-checked far fa-check-square"></i><i class="fas fa-percent"></i>Common
                  Size
                </span>
              }
              @if (!commonSize) {
                <span>
                  <i class="far fa-square"></i><i class="fas fa-percent"></i>Common Size
                </span>
              }
            </div>
            <div class="btn-group clickable-text" role="toolbar"
              [class.disabled]="trendDisabled" (click)="toggleTrend()">
              @if (trend) {
                <span class="item-checked">
                  <i class="item-checked far fa-check-square"></i><i class="fas fa-chart-line"></i>Trend
                </span>
              }
              @if (!trend) {
                <span>
                  <i class="far fa-square"></i><i class="fas fa-chart-line"></i>Trend
                </span>
              }
            </div>
            @if (this.activeDataView.templated) {
              <div class="btn-group clickable-text" role="toolbar"
                [class.disabled]="sourceItemsDisabled" (click)="toggleSourceItems()">
                @if (sourceItems) {
                  <span class="item-checked">
                    <i class="item-checked far fa-check-square"></i><i class="fas fa-list-ul"></i>Source Items
                  </span>
                }
                @if (!sourceItems) {
                  <span>
                    <i class="far fa-square"></i><i class="fas fa-list-ul"></i>Source Items
                  </span>
                }
              </div>
            }
            <div class="btn-group" role="toolbar">
              <label class="d-flex align-items-center"  style="padding-right: 8px;">Display In:
              </label>
              <select (change)="roundingSelectionChanged($event)" class="form-select w-auto" id="roundingInput"
                [value]="multiply_by_factor" style="font-size: 12px;">
                <option value="ACTUALS">Actuals</option>
                <option value="THOUSANDS">Thousands</option>
                <option value="MILLIONS">Millions</option>
                <option value="BILLIONS">Billions</option>
                <option value="TRILLIONS">Trillions</option>
              </select>
            </div>
            @if (showFilterStatementsButton) {
              <button
                class="btn btn-outline-secondary filter-icon-button"
                (click)="openFilterStatementFlyout()"
                title="Filter Statements">
                <i class="fas fa-filter"></i>
              </button>
            }
            <app-popover-menu
              [menuItems]="actionMenuItems"
              buttonText="Actions"
            ></app-popover-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="financials-container">
      <div class="row">
        @if (isFootnotesViewOn) {
          <div class="splitscreen-wrapper col-6 col-sm-6 col-md-6 col-lg-6">
            <financial-summary-split-screen
              [activePage]="activeFootnotePage"
              [readOnlyCropper]="cropper"
              [docFileId]="docFileId"
              (closeSplitscreen)="closeFootnotes()"
            ></financial-summary-split-screen>
          </div>
        }
                    <div [ngClass]="{
                      'table_container': 'true',
                      'embedded-financials-container': embeddedMode,
                      'footnotes-open': isFootnotesViewOn,
                      'col-6': isFootnotesViewOn,
                      'col-12': !isFootnotesViewOn,
                      'statement-builder-flyout-open': isStatementBuilderFlyoutOpen,
                      'filter-statements-flyout-open': isFilterStatementsFlyoutOpen,
                      'comment-view-flyout-open': isCommentViewOpen,
                      'col-9': isCommentViewOpen,
                  }">
                        <div #analysisTableComponent class="scroll financials-table" [ngClass]="
                          {
                              'extra-space-insights': !isGraphShown && showInsights,
                              '': !isGraphShown && !showInsights,
                              'embedded-financials': embeddedMode
                          }"
            >
            @if (!activeDataView || !activeDataView.rows.length) {
              <div>
                <div class="empty-state-container">
                  <app-table-empty-state
                    [emptyStateIcon]="noSourceDataExistsIcon"
                    [headerText]="noSourceDataExistsHeaderText"
                    [helpText]="noSourceDataExistsHelpText"
                  ></app-table-empty-state>
                </div>
              </div>
            }
            @if (activeDataView && activeDataView.rows.length) {
              <div>
                <app-financials-table
                  [multiply_by_factor]="multiply_by_factor"
                  [rows]="activeDataView.rows"
                  [hiddenRowIndices]="hiddenRows"
                  [columns]="activeDataView.columns"
                  [hiddenColumnIndices]="hiddenColumns"
                  [showNumbers]="numbers"
                  [showCommonSize]="commonSize"
                  [showTrend]="trend"
                  [showSourceItems]="sourceItems"
                  [documentMenuItems]="documentMenuItems"
                  [allowEditCells]="activeDataView.raw"
                  [showHidden]="showHidden"
                  [dollarSign]="dollarSign"
                  [showSpreadingInContextMenu]="showSpreadingInContextMenu"
                  [statementType]="formatDataViewName(activeDataView.title)"
                  [companyId]="company.id"
                  [templated]="activeDataView.templated"
                  [projectionScenarioTypeLabelOverride]="projectionScenarioTypeLabelOverride"
                  [insightHighlightRefs]="insightHighlightRefs"
                  [insightHighlightColumnIndex]="insightHighlightColumnIndex"
                  [insightSelectedRowRef]="insightSelectedRowRef"
                  (rowToggled)="rowToggled($event)"
                  (toggleRowVisibility)="toggleRowVisibility($event)"
                  (columnHidden)="columnHidden($event)"
                  (openFootnotes)="openFootnotesOrSourceBox($event)"
                  (openInsights)="openInsights($event)"
                  (updateInsightSource)="updateInsightSource($event)"
                  [insightsLoadingComplete$]="insightsLoadingComplete$"
                  (beginDeleteColumn)="beginDeleteColumn($event)"
                  (beginEditColumn)="beginEditColumn($event)"
                  (beginDuplicateColumn)="beginDuplicateColumn($event)"
                  (openCommentView)="openCommentView($event)"
                  (openCellCommentView)="openCommentView(null, $event.cellInformation, $event.cellTitle, $event.cellStatementDate)"
                  [viewOnlyMode]="pageViewMode===COMPANY_PAGE_VIEW_MODE.VIEW_ONLY"
                  [embeddedMode]="embeddedMode"
                  [commonSizeDecimalPrecision]="commonSizeDecimalPrecision"
                  >
                </app-financials-table>
              </div>
            }
          </div>
          @if (isGraphShown) {
            <div class='chart-container'>
              <div class='card mb-3'>
                <div class='chart-header card-header'>
                  @if (graphItems.length > 0) {
                    {{ graphItemLabels }}
                  }
                  <div class="chart-close" (click)="closeGraph()">
                    <i class="fas fa-times clickable"></i>
                  </div>
                </div>
                <div class="card-body chart-body">
                  <app-graph [graphItems]="graphItems" [height]="300" [width]="1000"
                    [bottomOffset]="GRAPH_NAVBAR_OFFSET_PX" [yAxisLabel]="graphYAxisLabel">
                  </app-graph>
                </div>
              </div>
            </div>
          }
          @if (showInsights && viewInsightsV2Enabled) {
            <app-insights-v2 class='insights-v2-container' [class.has-scrollbar]="hasVerticalScrollbar"
              [activeDataView]="activeDataView"
              [companyId]="company.id"
              [insightEquationComponents]="insightEquationComponents"
              [visibleColumnMetadata]="visibleColumnMetadata"
              [currency]="insightsCurrency"
              [showCurrency]="dollarSign"
              [showHidden]="showHidden"
              [showTrend]="trend"
              [showCommonSize]="commonSize"
              [commonSizeDecimalPrecision]="commonSizeDecimalPrecision"
              [showLoadingView]="insightsIsLoading"
              [multiplyByFactor]="multiply_by_factor"
              (closeInsights)="closeInsights()"
              (openSourceBox)="openFootnotesOrSourceBox($event)"
            ></app-insights-v2>
          }
          @if (showInsights && !viewInsightsV2Enabled) {
            <div class='insights-container'>
              <div class='card mb-3'>
                <div class='chart-header card-header insight-header'>
                  {{ currentInsightLabel }}
                  <div style="display: inline; font-weight: normal; margin-left: 10px;">
                    {{ insightsPayload.statementDate }}
                  </div>
                  <div class="chart-close" (click)="closeInsights()">
                    <i class="fas fa-times clickable"></i>
                  </div>
                  @if (insights[0]?.components[0].prevValue !== null) {
                    <div class="insights-comparison-label"
                      >
                      Comparison to previous period <span
                      class="insights-prior-period-metadata">({{ insights[0].priorPeriodMetadataString }}
                    )</span>
                  </div>
                }
                @if (insights[0]?.components[0].prevValue === null) {
                  <div class="insights-comparison-label"
                    >
                    No period available for comparison
                  </div>
                }
              </div>
                                <div class="insights-inner-container" [ngClass]="{
                                'embedded-mode-insights': embeddedMode,
                                'standalone-mode-insights': !embeddedMode
                              }">
                @for (insight of insights; track insight; let insightIdx = $index) {
                  <div>
                    <app-insights
                      [insights]="insight"
                      [currency]="insightsCurrency"
                      (detailSelected)="openInsightsDetail($event, insightIdx)"
                      (detailClosed)="closeInsightsDetail($event, insightIdx)"
                      (footnoteSelected)="openFootnotesOrSourceBox($event)"
                      (sourceBoxSelected)="openFootnotesOrSourceBox($event)"
                    ></app-insights>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      @if (isStatementBuilderFlyoutOpen) {
        <div class="col-5 statement-builder-flyout-container">
          <div class="statement-builder-flyout">
            <app-statement-builder-flyout
              [company]="company"
              [embeddedMode]="embeddedMode"
              [columns]="activeDataView.columns"
              [rows]="activeDataView.rows"
              [spreadingTemplateItems]="spreadingTemplateItems"
              [statementBuilderEditMode]="statementBuilderEditMode"
              [frameToBeEditedId]="frameToBeEditedId"
              (closeStatementBuilderFlyout)="closeStatementBuilderFlyout($event)"
            ></app-statement-builder-flyout>
          </div>
        </div>
      }
      @if (isFilterStatementsFlyoutOpen) {
        <div class="col-4 filter-statements-flyout-container">
          <div class="filter-statements-flyout">
            <app-filter-statements
              [columns]="activeDataView.columns"
              [periodOptions]="periodOptions"
              [selectedPeriods]="selectedPeriods"
              [hiddenColumnIndices]="hiddenColumns"
              [showHiddenDisabled]="showHiddenDisabled"
              [removeHiddenDisabled]="removeHiddenDisabled"
              [clearUndoDisabled]="clearUndoDisabled"
              [multiSelectOptionsForReportingInterval]="reportingIntervalFilter"
              [multiSelectOptionsForYears]="yearsFilter"
              [multiSelectOptionsForScenario]="scenarioFilter"
              [multiSelectOptionsForMonthsCovered]="monthsCoveredFilter"
              [hideRowColUndoStack]="hideRowColUndoStack"
              [shouldResetEverything]="shouldResetEverything"
              (callback)="closeFilterStatementsFlyout($event)"
            ></app-filter-statements>
          </div>
        </div>
      }
      <div class="col-3 comment-view-flyout-container" [ngClass]="{'comment-view-open': isCommentViewOpen}">
        <div class="comment-view-flyout">
          <app-comment-sidebar
            [activeDataView]="activeDataView"
            [selectedColumn]="selectedColumnForComments"
            (closeCommentView)="closeCommentView()">
          </app-comment-sidebar>
        </div>
      </div>
    </div>
  </div>
  <div class="navbar-container">
    <nav class="navbar navbar-light navbar-expand navbar-financials p-0">
      <ul class="navbar-nav financial-tabs">
        @for (view of dataViewsList; track view) {
          <li [ngClass]="{'nav-active': dataViewId === view.id, 'active': dataViewId === view.id }"
            class="nav-item">
            <a class="nav-link" [routerLink]="dataViewRouterLink(view.id)">
              {{ formatDataViewName(view.title) }}
            </a>
          </li>
        }
      </ul>
    </nav>
  </div>
</div>
} @else {
  @if (!hasDocuments) {
    <div class="empty-state-container">
      <div>
        <app-table-empty-state
          [emptyStateIcon]="noFinancialsExistIcon"
          [headerText]="noFinancialsExistHeaderText"
          [helpText]="noFinancialsExistHelpText"
        ></app-table-empty-state>
      </div>
      <div class="upload-button-container">
        @if (showEmptyStateUploadButton) {
          <button (click)="openUploadDocumentModal()"
            class="btn btn-primary" type="button">
            <i class="fa-solid fa-arrow-up-from-bracket"></i>
            <span>Upload Documents</span>
          </button>
        }
      </div>
    </div>
  }
  @if (hasDocuments) {
    <div class="empty-state-container">
      <div>
        <app-table-empty-state
          [emptyStateIcon]="noFinancialsExistIcon"
          [headerText]="noFinancialsCompleteHeaderText"
          [helpText]="noFinancialsCompleteHelpText"
        ></app-table-empty-state>
      </div>
      <div class="upload-button-container hasDoc">
        @if (showEmptyStateUploadButton) {
          <button
            [routerLink]="['/companies', company.uuid, 'data']"
            class="btn btn-primary" type="button">
            <span>View Uploaded Documents</span>
            <i class="fa-solid fa-arrow-right hasDoc"></i>
          </button>
        }
      </div>
    </div>
  }
}
</div>
}

